import { Badge } from '@chakra-ui/react/badge';

interface Props {
	score: number;
}

const MetaCritic = ({ score }: Props) => {
	if (!score) return null;

	const palette = score > 75 ? 'green' : score > 60 ? 'yellow' : 'red';

	return (
		<Badge
			colorPalette={palette}
			fontSize="xs"
			fontWeight="800"
			paddingX={2}
			paddingY={0.5}
			borderRadius="md"
			variant="solid"
		>
			{score}
		</Badge>
	);
};

export default MetaCritic;
